import axios from "./userInstance"

export default async (role_id: string, permissionIds: string[]) => {
  const payload = {
    "role_id": role_id,
    "permission_ids": permissionIds,
  };
  const response = await axios.post(`/role/permissions`, payload)
  return response.data
}
